import { Doughnut, mixins } from 'vue-chartjs'

const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    // this.chartData 在 mixin 创建.
    // 如果你需要替换 options , 请创建本地的 options 对象
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    options(newVal) {
      this.renderChart(this.chartData, newVal);
    },
    chartData(newVal) {
      this.renderChart(newVal, this.options);
    }
  },
}